import { useMutation } from '@tanstack/react-query';
import {
  submitCustomSurveyResponse,
  SubmitCustomSurveyRequest,
  SubmitCustomSurveyResponse,
} from '../../api/customSurveys';

export const useSubmitCustomSurveyMutation = (uuid: string) => {
  return useMutation({
    mutationFn: (data: SubmitCustomSurveyRequest): Promise<SubmitCustomSurveyResponse> =>
      submitCustomSurveyResponse(uuid, data),
  });
};
